import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import TermosDeUso from "@/pages/TermosDeUso";

export const Route = createFileRoute("/termos-de-uso")({
  head: () => buildHead({
    title: "Termos de Uso | OP2P CRM e Agentes de IA",
    description: "Condições de uso do sistema OP2P CRM e Agentes de IA: direitos, responsabilidades, contratação e regras de utilização do serviço.",
    path: "/termos-de-uso",
  }),
  component: TermosDeUso,
});
